<div
  class="h-full flex flex-col w-full lg:flex-row shadow-primary-900/10 rounded-lg overflow-hidden hover:shadow-1xl hover:shadow-primary-500/30 transition-all"
  [ngClass]="{
    'flex-row lg:flex-col shadow-lg': direction === 'ver',
    'hover:shadow-secondary-500/20': campaign?.IsDelivery
  }"
>
  <picture
    class="relative block w-full aspect-[3/2] bg-slate-200 bg-cover bg-center"
    [ngClass]="{ 'lg:w-3/5': direction === 'hor' }"
  >
    <img
      class="object-cover text-transparent relative"
      [ngSrc]="
        campaign?.CampaignOfferType === offerTypeEnum.Item
          ? campaign?.MainPicture || defaultImg
          : campaign?.CommercialPlaceLogoImagePath! || defaultImg
      "
      fill
      [priority]="direction === 'hor' || !campaign?.MainPicture"
      [alt]="campaign?.Title"
    />
    <div
      *ngIf="direction === 'hor'"
      class="hidden lg:block absolute right-0 w-1 h-full bg-gradient-to-b from-white bg-repeat-y bg-[length:4px_20px] from-60% to-0%"
    ></div>
    <div
      *ngIf="direction === 'hor'"
      class="lg:hidden absolute bottom-0 w-full h-1 bg-gradient-to-r from-white bg-repeat-x bg-[length:20px_4px] from-60% to-0%"
    ></div>
    <div
      *ngIf="direction === 'ver'"
      class="absolute bottom-0 w-full h-1 bg-gradient-to-r from-white bg-repeat-x bg-[length:20px_4px] from-60% to-0%"
    ></div>
  </picture>

  <div
    class="p-6 flex flex-1 flex-col relative"
    [ngClass]="{ 'items-center justify-center': direction === 'hor' }"
  >
    <div
      class="flex items-center group"
      [ngClass]="{
        'cursor-pointer': direction == 'hor',
        'mb-4': campaign?.CampaignOfferType === offerTypeEnum.Item
      }"
      (click)="direction === 'hor' && redirectToRestaurantEmitter()"
    >
      <img
        *ngIf="campaign?.CampaignOfferType === offerTypeEnum.Item"
        class="rounded-full mr-3 bg-slate-200 relative"
        [ngSrc]="campaign?.CommercialPlaceLogoImagePath || defaultImg"
        width="40"
        height="40"
        [alt]="campaign?.CommercialPlaceTradeName"
      />
      <div
        class="h-10"
        *ngIf="campaign?.CampaignOfferType === offerTypeEnum.Restaurant"
      ></div>
      <div
        class="text-base font-medium tracking-tight truncate"
        [ngClass]="{ 'group-hover:text-primary-500': direction == 'hor' }"
        [title]="campaign?.CommercialPlaceTradeName"
      >
        {{ campaign?.CommercialPlaceTradeName }}
      </div>
    </div>
    <h4
      *ngIf="campaign?.CampaignOfferType === offerTypeEnum.Item"
      class="text-2xl font-semibold mb-3"
      [ngClass]="direction === 'ver' ? 'truncate' : 'text-center'"
      [title]="campaign?.Title"
    >
      {{ campaign?.Title }}
    </h4>
    <div
      class="flex mb-3"
      *ngIf="campaign?.CampaignOfferType === offerTypeEnum.Item"
    >
      <div class="text-justify text-2xl font-semibold mr-3">
        {{ campaign?.PromotionalValue | currency }}
      </div>
      <div
        class="text-justify text-slate-400 text-2xl font-normal line-through"
      >
        {{ campaign?.CurrentValue | currency }}
      </div>
    </div>
    <div
      class="flex flex-col mb-3"
      *ngIf="campaign?.CampaignOfferType === offerTypeEnum.Restaurant"
    >
      <div
        class="flex items-center text-justify text-neutral-950 font-medium"
        *ngIf="campaign?.DisplayAsPercentage"
      >
        <span class="text-6xl">{{ campaign?.DiscountValue }}</span>
        <span class="text-6xl mr-1"> % </span>

        <span class="text-3xl"> OFF</span>
      </div>
      <div
        class="flex items-center text-justify text-neutral-950 font-medium"
        *ngIf="!campaign?.DisplayAsPercentage"
      >
        <span class="text-3xl mr-1"> R$ </span>
        <span class="text-6xl mr-1">{{ campaign?.PromotionalValue }}</span>
        <span class="text-3xl"> OFF</span>
      </div>
      <p class="text-xl text-gray-400">
        Consumo mínimo {{ campaign?.MinimumPromotionalValue | currency }}
      </p>
    </div>
    <div class="overflow-hidden" [ngClass]="{ 'h-9': direction === 'ver' }">
      <div
        class="flex gap-1 overflow-x-auto pb-2 no-scrollbar"
        [ngClass]="{ 'flex-wrap justify-center': direction === 'hor' }"
      >
        @if(campaign?.IsDelivery){
        <div
          class="px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap text-slate-500 bg-white border border-slate-500"
        >
          Delivery
        </div>
        }
        <ng-container *ngFor="let weekVisibility of campaign?.WeekVisibility">
          <div
            *ngFor="let moment of weekVisibility.Moments"
            class="px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap text-slate-500 bg-white border border-slate-500"
          >
            {{ moment.Name }}
          </div>
        </ng-container>
      </div>
    </div>
    <div
      class="text-xs font-medium flex items-center gap-2"
      *ngIf="campaign?.CouponDailyCount"
      [ngClass]="scarcityLevel.color"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 5V7" stroke="currentColor" stroke-width="1.2" />
        <path d="M9 10V14" stroke="currentColor" stroke-width="1.2" />
        <path d="M9 17V19" stroke="currentColor" stroke-width="1.2" />
        <path
          d="M9.5 4.5H20.5C21.0523 4.5 21.5 4.94772 21.5 5.5V8.5C21.5 9.05228 21.0523 9.5 20.5 9.5H20V9.5C19.1716 9.5 18.5 10.1716 18.5 11V12V13C18.5 13.8284 19.1716 14.5 20 14.5V14.5H20.5C21.0523 14.5 21.5 14.9477 21.5 15.5V18.5C21.5 19.0523 21.0523 19.5 20.5 19.5H9.59573M8.5 4.5H3.5C2.94772 4.5 2.5 4.94772 2.5 5.5V8.5C2.5 9.05228 2.94772 9.5 3.5 9.5H4V9.5C4.82843 9.5 5.5 10.1716 5.5 11V13C5.5 13.8284 4.82843 14.5 4 14.5V14.5C3.84818 14.5 3.67431 14.5 3.5 14.5C2.94772 14.5 2.5 14.9477 2.5 15.5V18.5C2.5 19.0523 2.94772 19.5 3.5 19.5H8.40889"
          stroke="currentColor"
          stroke-width="1.2"
        />
      </svg>
      <ng-container *ngIf="campaign?.CouponDailyCount != 1">
        {{ campaign?.CouponDailyCount }} cupons disponíveis
      </ng-container>
      <ng-container *ngIf="campaign?.CouponDailyCount == 1">
        Último cupom disponível
      </ng-container>
    </div>
    <a
      target="_blank"
      rel="noopener noreferrer"
      *ngIf="direction === 'hor'"
      class="px-10 py-4 bg-primary-500 hover:bg-primary-700 rounded-full justify-center items-center inline-flex text-white text-3xl font-medium mt-10 cursor-pointer"
      (click)="deeplinkRedirect(campaign)"
    >
      Comprar
    </a>
    <div class="absolute right-6 top-6" *ngIf="direction === 'hor'">
      <div
        class="cursor-pointer"
        (click)="copyUrl(campaign)"
      >
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.833 18L16.8916 21.2191M12.0321 14.4292L17.0021 10.8792"
            stroke="#020617"
            stroke-width="1.2"
            stroke-linecap="square"
          />
          <path
            d="M29.1663 15.9999C29.1663 22.6666 23.8635 28.6666 16.4997 28.6666C9.13588 28.6666 3.83301 22.6666 3.83301 15.9999C3.83301 8.63612 9.83301 3.33325 16.4997 3.33325C23.1663 3.33325 29.1663 8.63612 29.1663 15.9999Z"
            stroke="#020617"
            stroke-width="1.2"
          />
          <ellipse
            cx="9.83366"
            cy="15.9999"
            rx="2.66667"
            ry="2.66667"
            stroke="#020617"
            stroke-width="1.2"
            stroke-linecap="round"
          />
          <ellipse
            cx="19.1667"
            cy="9.33342"
            rx="2.66667"
            ry="2.66667"
            stroke="#020617"
            stroke-width="1.2"
            stroke-linecap="round"
          />
          <circle
            cx="19.1667"
            cy="22.6667"
            r="2.66667"
            stroke="#020617"
            stroke-width="1.2"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
</div>
